import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Honeybadger, HoneybadgerErrorBoundary } from "@honeybadger-io/react";

const config = {
  apiKey: "hbp_3CXqpLXbTBe0rSmnmUrEWYVdtbHxvc1ewbYf",
  environment: process.env.NODE_ENV || "development",
};

const honeybadger = Honeybadger.configure(config);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HoneybadgerErrorBoundary honeybadger={honeybadger}>
      <App />
    </HoneybadgerErrorBoundary>
  </React.StrictMode>
);
